import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProductDetailDto } from 'src/store/products/product';
import { formatDate } from 'src/utils/date';

export type LabelBodyProps = {
  product: ProductDetailDto;
};

export const CommonLabelBody: React.FC<LabelBodyProps> = ({ product }) => {
  const { t } = useTranslation();
  return (
    <>
      <p>
        <label>{t('product.runNo')}: </label>
        <span>{product.runNo}</span>
      </p>
      <p>
        <span>{product.runSystem.name}</span>
      </p>
      <p>
        <label>{t('product.norlab')}:</label>
        {product.norlabNo && <span>{product.norlabNo}</span>}
      </p>
      <p>
        <label>{t('product.eag')}:</label>
        <span>
          {product.runSystem.no}-{product.runNo}
        </span>
      </p>
      <p>
        <label>{t('grade.singular')}: </label>
        <span>{product.grade.name}</span>
      </p>
      <p>
        <label>{t('props.date')}: </label>
        <span>{formatDate(product.runDate)}</span>
      </p>
      {product.lotNo && (
        <p>
          <label>{t('product.lotNo')}: </label>
          <span>{product.lotNo}</span>
        </p>
      )}
      <p>
        <span>{product.runText}</span>
      </p>

      <textarea />
    </>
  );
};
